/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserEventResponse } from './UserEventResponse';
import {
    UserEventResponseFromJSON,
    UserEventResponseFromJSONTyped,
    UserEventResponseToJSON,
    UserEventResponseToJSONTyped,
} from './UserEventResponse';
import type { PageModel } from './PageModel';
import {
    PageModelFromJSON,
    PageModelFromJSONTyped,
    PageModelToJSON,
    PageModelToJSONTyped,
} from './PageModel';

/**
 * 
 * @export
 * @interface UserEventResponsePagedResult
 */
export interface UserEventResponsePagedResult {
    /**
     * 
     * @type {PageModel}
     * @memberof UserEventResponsePagedResult
     */
    pageInfo?: PageModel;
    /**
     * 
     * @type {Array<UserEventResponse>}
     * @memberof UserEventResponsePagedResult
     */
    data: Array<UserEventResponse> | null;
}

/**
 * Check if a given object implements the UserEventResponsePagedResult interface.
 */
export function instanceOfUserEventResponsePagedResult(value: object): value is UserEventResponsePagedResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UserEventResponsePagedResultFromJSON(json: any): UserEventResponsePagedResult {
    return UserEventResponsePagedResultFromJSONTyped(json, false);
}

export function UserEventResponsePagedResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserEventResponsePagedResult {
    if (json == null) {
        return json;
    }
    return {
        
        'pageInfo': json['pageInfo'] == null ? undefined : PageModelFromJSON(json['pageInfo']),
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(UserEventResponseFromJSON)),
    };
}

export function UserEventResponsePagedResultToJSON(json: any): UserEventResponsePagedResult {
    return UserEventResponsePagedResultToJSONTyped(json, false);
}

export function UserEventResponsePagedResultToJSONTyped(value?: UserEventResponsePagedResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageInfo': PageModelToJSON(value['pageInfo']),
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(UserEventResponseToJSON)),
    };
}

